import React, {
    useCallback,
    useEffect,
    useState,
    useMemo,
    useRef,
} from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { format, formatISO, parseISO } from 'date-fns';
import { isEmpty, isArray } from 'lodash';
import qs from 'querystring';
import axios from 'axios';

import { Table } from '~/components';
import { TableSearchListdDef } from '~/componentslocal';
import { RadioGroup, Input } from '~/components/Form';
import { t, number, parseDateString } from '~/helpers';
import api from '~/services/api';

import * as S from './styles';
import { parseISOWithOptions } from 'date-fns/fp';
// import MinimizableTable from '../MinimizableTable';

export default function RecordDetails({
    data,
    sending,
    visible,
    toggleDisabled,
}) {

    const { token } = useSelector((state) => state.auth);
    const { profile } = useSelector((state) => state.user);

    const currentDate = useMemo(() => format(new Date(), 'dd/MM/yyyy HH:mm'), [])
    const [resultados, setResultados] = useState({
        m_tanque: { amb: 0, grau20: 0 },
        r_sistema: { amb: 0, grau20: 0 },
        d_apurada: { amb: 0, grau20: 0 }
    })

    const [dataTable, setDataTable] = useState([])

    const formRef = useRef(null);


    useEffect(() => {
        if (!isEmpty(data))
            handleGetData(data)
    }, [data, profile])

    const handleGetData = useCallback(async (values) => {
        let params = {
            wherefield: ['turn_cod_turn', 'post_cod_posto', 'tipoRel'],
            valuewherefield: [values.turn_cod_turn, values.post_cod_posto, 2],
            typewherefield: ['EQUALS', 'EQUALS', 'EQUALS']

        }

        const response = await api.get('apuracaoinventario', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        })

        let somaVolAmb = 0
        let somaVol20 = 0

        let registradoAmb = 0
        let registrado20 = 0

        if (!isEmpty(response.data.items)) {
            response.data.items.forEach((item) => {
                somaVolAmb += item.meta_vol_prod_amb
                somaVol20 += item.meta_vol_prod_20
            })

            registradoAmb = somaVolAmb == 0 ? 0 : response.data.items[0].tatu_vol_contabil_amb_fim
            registrado20 = somaVol20 == 0 ? 0 : response.data.items[0].tatu_vol_contabil_20_fim

        }
        setResultados({
            m_tanque: { amb: somaVolAmb.toFixed(1), grau20: somaVol20.toFixed(1) },
            r_sistema: { amb: registradoAmb.toFixed(1), grau20: registrado20.toFixed(1) },
            d_apurada: { amb: (somaVolAmb - registradoAmb).toFixed(1), grau20: (somaVol20 - registrado20).toFixed(1) }
        })

        setDataTable(response.data.items)
    }, [])

    const tableHeader = useMemo(() => [
        {
            id: 'tafi_cod_tafi',
            label: 'Tanque'
        },
        {
            id: 'meta_cm_tot',
            label: 'Produto Altura'
        },
        {
            id: 'meta_vol_prod_amb',
            label: 'Produto Vol Amb'
        },
        {
            id: 'meta_vol_prod_20',
            label: 'Produto Vol 20'
        },
        {
            id: 'meta_cm_agua',
            label: 'Água Altura'
        },
        {
            id: 'meta_vol_agua',
            label: 'Água Volume'
        },
        {
            id: 'meta_temp_superficie',
            label: 'Temp. Superfície'
        },
        {
            id: 'meta_temp_meio',
            label: 'Temp. Meio'
        },
        {
            id: 'meta_temp_fundo',
            label: 'Temp. Fundo'
        },
        {
            id: 'meta_temp_media',
            label: 'Temp. Média'
        },
        {
            id: 'bate_dens_amb',
            label: 'Amostra Dens. Amb.'
        },
        {
            id: 'bate_temp_amostra',
            label: 'Amostra Temp.'
        },
        {
            id: 'bate_dens_20',
            label: 'Amostra Desn. 20'
        },

    ], [])



    const optionsTypeRadio = useMemo(
        () => [
            { label: 'PDF', value: 'pdf' },
            { label: 'Excel', value: 'xls' },
        ],
        []
    );



    const handleSubmit = useCallback(
        async (formData) => {
            try {
                toggleDisabled(true);

                const REACT_APP_URL_DOWNLOAD = sessionStorage.getItem('URL_REPORT');
                const dataFilter = {
                    relatorio: 'APUINVENTARIO',
                    token,
                    post_cod_posto: data.post_cod_posto,
                    posto_str: data.post_desc,
                    turn_datahora_ini: data.filter_datahora_ini,
                    turn_datahora_fim: data.filter_datahora_fim,
                    tipoRel: 2,
                    codTurno: data.turn_cod_turn,
                    ...JSON.parse(JSON.stringify(formData)),
                };

                const url = new URL(REACT_APP_URL_DOWNLOAD);
                url.search = new URLSearchParams(dataFilter);

                const response = await axios({
                    url: url.href,
                    method: 'POST',
                    responseType: 'blob',
                });

                const file = new Blob([response.data], { type: response.data.type });

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file);
                } else {
                    const objectUrl = URL.createObjectURL(file);
                    window.open(objectUrl);
                }
            } catch (err) {
                if (isArray(err)) err.map((e) => toast.error(t(e)));
                else toast.error(t(err));
            } finally {
                toggleDisabled(false);
            }
        },
        [token, profile, data]
    );

    useEffect(() => {
        if (sending) formRef.current.submitForm();
    }, [sending]);

    return (
        <S.Wrapper
            ref={formRef}
            initialData={{ tipo: 'pdf' }}
            onSubmit={handleSubmit}
        >
            {visible && <>
                <ul>
                    <li>
                        <span>Data Emissão:</span>
                        {currentDate}
                    </li>
                    <li>
                        <span>Período:</span>
                        {`${format(parseDateString(data.filter_datahora_ini), 'dd/MM/yyyy HH:mm:ss')} até 
                        ${format(parseDateString(data.filter_datahora_fim), 'dd/MM/yyyy HH:mm:ss')}`}
                    </li>
                    <li>
                        <span>Emissor:</span>
                        {profile.username}
                    </li>
                    <li>
                        <span>Posto:</span>
                        {data.post_desc}
                    </li>
                </ul>

                <S.WrapperHeading>Turno</S.WrapperHeading>

                <S.WrapperOL columns={3}>
                    <li>
                        <span>Turno Inicial: </span>
                        {format(parseISO(data.turn_datahora_ini), 'dd/MM/yyyy HH:mm:ss')}
                    </li>
                    <li>
                        <span>Turno Final: </span>
                        {format(parseISO(data.turn_datahora_fim), 'dd/MM/yyyy HH:mm:ss')}
                    </li>
                    <li>
                        <span>Responsável: </span>
                        {data.oper_nome}
                    </li>
                </S.WrapperOL>

                <S.WrapperHeading>Medições de Tanque</S.WrapperHeading>
                <TableSearchListdDef
                    cells={tableHeader}
                    data={dataTable}
                    size="small"
                    paginate={3}
                    showCount
                />

                <S.SmallWrapperHeading>Resultados</S.SmallWrapperHeading>
                <S.SmallWrapperOL columns={3}>
                    <li>
                        <span>Volume Total</span>
                    </li>
                    <li>
                        <span>Ambiente</span>
                    </li>
                    <li>
                        <span>20°</span>
                    </li>
                    <li>
                        Mensurado no Tanque
                    </li>
                    <li>
                        {resultados.m_tanque.amb}
                    </li>
                    <li>
                        {resultados.m_tanque.grau20}
                    </li>
                    <li>
                        Registrado no Sistema
                    </li>
                    <li>
                        {resultados.r_sistema.amb}
                    </li>
                    <li>
                        {resultados.r_sistema.grau20}
                    </li>
                    <li>
                        Diferença Apurada
                    </li>
                    <li>
                        {resultados.d_apurada.amb}
                    </li>
                    <li>
                        {resultados.d_apurada.grau20}
                    </li>
                </S.SmallWrapperOL>

                <div style={{ marginTop: '2rem', marginBottom: '2rem' }}>
                    <RadioGroup
                        row
                        name="tipo"
                        label="Formato"
                        options={optionsTypeRadio}
                    />
                </div>

            </>}

        </S.Wrapper >
    );
}

RecordDetails.propTypes = {
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    sending: PropTypes.bool.isRequired,
    visible: PropTypes.bool.isRequired,
    toggleDisabled: PropTypes.func.isRequired,
};
